import { makeStyles } from '@fluentui/react';
import { DRAWER_CLOSE_WIDTH, DRAWER_OPEN_WIDTH } from 'common/constants';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0 13px',
  },
  logoContainer: {
    height: 24,
    marginBottom: 6,
  },
  logoContainerExpanded: {
    width: DRAWER_OPEN_WIDTH,
  },
  logoContainerCollapsed: {
    width: DRAWER_CLOSE_WIDTH,
  },
  logo: {
    color: theme.palette.neutralPrimary,
    lineHeight: 0,
    textDecoration: 'none',
  },
  logoText: {
    color: theme.palette.neutralPrimary,
    paddingLeft: 6,
  },

  icon: {
    fontSize: 18,
    color: theme.palette.neutralSecondaryAlt,
  },
  iconButton: {
    minWidth: 48,
    ':hover': { backgroundColor: theme.palette.neutralLighterAlt },
  },
  closeButton: {
    width: 16,
    height: 16,
    paddingTop: 4,
    background: 'transparent',

    selectors: {
      ':hover': {
        background: 'rgba(255,255,255,0.15)',
      },
    },
  },

  closeIcon: {
    fontSize: 14,
    color: theme.palette.black,
  },

  closeIconHovered: {
    color: theme.palette.white,
  },
  commandButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 6px',
    cursor: 'pointer',
  },

  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
    borderRadius: 4,

    selectors: {
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
      ':active': {
        backgroundColor: theme.palette.neutralLight,
      },
    },
  },
  calloutRoot: {
    border: `1.5px solid ${theme.palette.orangeLighter}`,
    borderRadius: 4,
    padding: '6px 10px',
    background: theme.palette.white,
    cursor: 'pointer',
  },

  calloutWidthMessage:
  {
    width: 135
  },

  calloutHovered: {
    background: theme.palette.orangeLighter,
  },

  calloutBeak: {
    background: theme.palette.white,
    border: `1.5px solid ${theme.palette.orangeLighter}`,
  },

  calloutBeakHovered: {
    background: theme.palette.orangeLighter,
  },

  calloutMain: {
    background: theme.palette.white,
    overflow: 'hidden',
  },

  calloutMainHovered: {
    background: theme.palette.orangeLighter,
  },

  calloutText: {
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap',
    color: theme.palette.black,
  },

  calloutTextHovered: {
    color: theme.palette.white,
  },
}));
